export const NEW_SESSION_MSG = "New session started!";

export const FLAG_REASONS = [
  "Incorrect information",
  "Off-brand tone",
  "Mentioned a competitor",
  "Too salesy",
  "Missing key information",
  "Confusing or unclear",
];

/** Format a timestamp as "Jan 1, 2025" for conversation history lists. */
export function formatSessionDate(timestamp, locale = undefined) {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** Format a timestamp as a locale date + time string for interaction rows. */
export function toDateTimeString(timestamp, locale = undefined) {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return "";
  const dateStr = d.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const timeStr = d.toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "2-digit",
  });
  return `${dateStr}, ${timeStr}`;
}

/** Convert an optional ms timestamp to an ISO-8601 string, defaulting to now. */
export function toISO(timestamp) {
  const t = timestamp || Date.now();
  return new Date(t).toISOString();
}
